"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _color = require("../../utils/color.utils");
var _lodash = require("lodash");
var _shared = require("../../utils/shared.utils");
var _mixins = require("../../styles/mixins");
var _excluded = ["hover", "selected", "disabled"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Figma: All variants: https://www.figma.com/file/R2XdHLuoVV8ScYIoH2Pm0Y/Bluxome-UI?node-id=1901-7556&t=xZv9Qg3XvJiJCECT-4
// Figma: Spec document: https://www.figma.com/file/IWWOK7MRPt8QBZVws6qWQg/Bluxome-Guidelines?node-id=1511-41081&t=wQenLLTfxVHEDWmq-4

var SIZES = {
  xxs: {
    size: 20
  },
  xs: {
    size: 30
  },
  sm: {
    size: 36
  },
  md: {
    size: 42
  },
  lg: {
    size: 48
  },
  xl: {
    size: 48
  }
};
var LIGHT = {
  color: _colors["default"].white,
  hover: {
    color: _colors["default"].white
  },
  selected: {
    color: _colors["default"].white
  }
};
var NEUTRAL = {
  color: _colors["default"].textPrimary,
  hover: {
    color: _colors["default"].textPrimary
  },
  selected: {
    color: _colors["default"].textPrimary
  }
};
var SUBTLE = {
  color: _colors["default"].neutral600,
  hover: {
    color: _colors["default"].textTertiary
  },
  selected: {
    color: _colors["default"].textTertiary
  }
};
var ACCENT = {
  color: _colors["default"].blue20,
  hover: {
    color: _colors["default"].blue20
  },
  selected: {
    color: _colors["default"].blue20
  }
};
var DEFAULT_SHADOW = {
  boxShadow: '0px 6px 16px rgba(0, 0, 33, 0.1), 0px 0px 2px 1px rgba(0, 0, 33, 0.05)'
};
var ACTIVE_SHADOW = {
  boxShadow: '0px 6px 16px rgba(0, 0, 33, 0.13), 0px 0px 2px 1px rgba(0, 0, 33, 0.08)'
};
var FLOATING = _objectSpread(_objectSpread({}, DEFAULT_SHADOW), {}, {
  hover: ACTIVE_SHADOW,
  selected: ACTIVE_SHADOW,
  disabled: DEFAULT_SHADOW
});
var INVISIBLE_CHARCOAL = {
  background: _colors["default"].transparent,
  hover: {
    background: (0, _color.applyOpacity)(_colors["default"].neutral800, 4)
  },
  selected: {
    background: (0, _color.applyOpacity)(_colors["default"].neutral800, 8)
  },
  disabled: {
    color: _colors["default"].neutral400,
    background: _colors["default"].transparent
  }
};
var INVISIBLE_WHITE = {
  background: _colors["default"].transparent,
  hover: {
    background: (0, _color.applyOpacity)(_colors["default"].white, 16)
  },
  selected: {
    background: (0, _color.applyOpacity)(_colors["default"].white, 25)
  },
  disabled: {
    color: (0, _color.applyOpacity)(_colors["default"].white, 30),
    background: _colors["default"].transparent
  }
};
var SOLID_CHARCOAL = {
  background: (0, _color.applyOpacity)(_colors["default"].neutral800, 4),
  hover: {
    background: (0, _color.applyOpacity)(_colors["default"].neutral800, 8)
  },
  selected: {
    background: (0, _color.applyOpacity)(_colors["default"].neutral800, 12)
  },
  disabled: {
    color: _colors["default"].neutral400,
    background: _colors["default"].transparent
  }
};
var FLOATING_CHARCOAL = (0, _lodash.merge)({}, FLOATING, {
  background: _colors["default"].white,
  hover: {
    background: _colors["default"].neutral100
  },
  selected: {
    background: _colors["default"].neutral100
  },
  disabled: {
    color: _colors["default"].neutral400,
    background: _colors["default"].white
  }
});
var STYLES = {
  'light-invisible': (0, _lodash.merge)({}, LIGHT, INVISIBLE_WHITE),
  'neutral-invisible': (0, _lodash.merge)({}, NEUTRAL, INVISIBLE_CHARCOAL),
  'neutral-solid': (0, _lodash.merge)({}, NEUTRAL, SOLID_CHARCOAL),
  'neutral-floating': (0, _lodash.merge)({}, NEUTRAL, FLOATING_CHARCOAL),
  'subtle-invisible': (0, _lodash.merge)({}, SUBTLE, INVISIBLE_CHARCOAL),
  'subtle-solid': (0, _lodash.merge)({}, SUBTLE, SOLID_CHARCOAL),
  'subtle-floating': (0, _lodash.merge)({}, SUBTLE, FLOATING_CHARCOAL),
  'accent-invisible': (0, _lodash.merge)({}, ACCENT, {
    background: _colors["default"].transparent,
    hover: {
      background: (0, _color.applyOpacity)(_colors["default"].blue20, 6)
    },
    selected: {
      background: (0, _color.applyOpacity)(_colors["default"].blue20, 12)
    },
    disabled: {
      color: (0, _color.applyOpacity)(_colors["default"].blue20, 30),
      background: _colors["default"].transparent
    }
  }),
  'accent-solid': {
    color: _colors["default"].white,
    background: _colors["default"].blue20,
    hover: {
      color: _colors["default"].white,
      background: _colors["default"].blue25
    },
    selected: {
      color: _colors["default"].white,
      background: _colors["default"].blue25
    },
    disabled: {
      color: _colors["default"].white,
      background: (0, _color.applyOpacity)(_colors["default"].blue20, 30)
    }
  },
  'accent-floating': (0, _lodash.merge)({}, ACCENT, FLOATING, {
    background: _colors["default"].white,
    hover: {
      background: (0, _color.applyOpacity)(_colors["default"].blue20, 5)
    },
    selected: {
      background: (0, _color.applyOpacity)(_colors["default"].blue20, 8)
    },
    disabled: {
      color: (0, _color.applyOpacity)(_colors["default"].blue20, 30),
      background: _colors["default"].white
    }
  }),
  'error-solid': {
    color: _colors["default"].red50,
    background: (0, _color.applyOpacity)(_colors["default"].red50, 15),
    hover: {
      color: _colors["default"].red50,
      background: (0, _color.applyOpacity)(_colors["default"].red50, 25)
    },
    selected: {
      color: _colors["default"].red50,
      background: (0, _color.applyOpacity)(_colors["default"].red50, 35)
    },
    disabled: {
      color: (0, _color.applyOpacity)(_colors["default"].red50, 30),
      background: _colors["default"].transparent
    }
  }
};
function getThemeStyle(_ref) {
  var theme = _ref.theme,
    loading = _ref.loading;
  var _STYLES$theme = STYLES[theme],
    hover = _STYLES$theme.hover,
    selected = _STYLES$theme.selected,
    disabled = _STYLES$theme.disabled,
    style = (0, _objectWithoutProperties2["default"])(_STYLES$theme, _excluded);
  return (0, _styledComponents.css)(["&,&:focus{", ";}&&:hover{", ";}", " &&:active,&&[data-state='open'],&&.selected{", "}&&&:disabled{cursor:not-allowed;", "}&&&&{", "}"], setStyles(style), setStyles(hover), (0, _mixins.focusState)(), setStyles(selected), setStyles(disabled), loading && setStyles(disabled));
}
function setStyles(style) {
  return (0, _styledComponents.css)(["background-color:", ";svg *{fill:", ";}&,*{color:", ";}", ""], style.background, style.color, style.color, style.boxShadow && (0, _styledComponents.css)(["box-shadow:", ";"], style.boxShadow));
}
var TRANSITION_DURATION = '80ms';
var IconButton = exports.IconButton = _styledComponents["default"].button.attrs(_shared.inertAttr).withConfig({
  displayName: "HBIconButtonstyles__IconButton",
  componentId: "sc-wlip0f-0"
})(["display:inline-flex;align-items:center;justify-content:center;border-radius:3px;transition-duration:", ";transition-property:background-color,box-shadow;position:relative;&&&{border:none;", "}i{display:flex;svg *{transition:fill ", ";}}&,*{transition:color ", ";}", " ", ""], TRANSITION_DURATION, function (props) {
  return (0, _styledComponents.css)(["margin:", ";"], props.$margin || 0);
}, TRANSITION_DURATION, TRANSITION_DURATION, function (props) {
  var size = "".concat(SIZES[props.size].size, "px");
  return (0, _styledComponents.css)(["min-width:", ";max-width:", ";min-height:", ";max-height:", ";padding:0;"], size, size, size, size);
}, getThemeStyle);
//# sourceMappingURL=HBIconButton.styles.js.map